import Vue from 'vue'
import Vuetify from 'vuetify'
import theme from './theme'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free/css/all.css'
import VueScrollTo from 'vue-scrollto'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueScrollTo)

library.add(faCoffee)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme,
})

Vue.use(VueReCaptcha, { siteKey: '6LfCfNsUAAAAAKyVewQ7O-pC1HD-ELqCZ-vWRwRt',  loaderOptions: {
  autoHideBadge: true
} })